import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { GroupUnlock } from "@shared/models/analytics/group"
import type { Group } from "@shared/models/group"
import type { PreparedAction } from "../../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../../create-narrative"

interface Payload {
  form: "teacher" | "admin" | "district-admin"
  group?: Group
}

export default function groupUnlockCopyLinkAction(payload: Payload): PreparedAction {
  return {
    name: "GROUP_UNLOCK_COPY_LINK",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  const groupUsedAs =
    payload.group?.attributes.usedAs ??
    (payload.form === "district-admin" ? "school-network" : "school")
  const groupTitle = payload.group?.attributes.title ?? "Generic Group"

  let newEvent: GroupUnlock = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "unlock",
    primary_possessive: "owns",

    primary_object_type: "group",
    primary_object_id: payload.group?.id || null,
    primary_object_specifier: groupUsedAs === "school-network" ? "school_network" : "school",
    primary_object_id_and_ancestor_ids: payload.group ? [payload.group.id] : [],

    adverbial_verb: "navigating",

    adverbial_object_type: "screen",
    adverbial_object_id: "copy_link",
    adverbial_object_specifier: payload.form,
  }

  return {
    title: "User copied group unlock link",
    titleForAnalytics: "Group - Unlock - Copy Link",
    description: `Copied unlock request link for ${groupUsedAs} ${groupTitle}`,
    context: {
      groupId: payload.group?.id,
      groupUsedAs,
      groupTitle,
      form: payload.form,
    },
    newAnalyticsEvents: [newEvent],
  }
}
